import { isInIntlBrowser, getLang } from "@/utils/tools";
import { game_id } from "@/utils/const";
import Login from "@/utils/login";

interface ReportTlogReq {
  action: string;
  sub_action?: string;
  ext_content?: Record<string, any>;
  original_game_id?: string;
  language?: string;
}
export const reportTlog = async (data: ReportTlogReq) => {
  const reportUrl = "https://na-community.playerinfinite.com/api/gpts_community.report_svr.ReportSvr/ReportStatInfo";
  const info = Login.info() || {};
  const lang = getLang();
  const params = {
    ...data,
    original_game_id: game_id,
    ext_content: JSON.stringify({
      ...data.ext_content,
      env: isInIntlBrowser,
      url: location.href,
      open_id: info.openid,
      lang,
    }),
  };
  const headerData = {
    "X-Language": lang || "en",
    "X-Gameid": '16',
    "X-Source":"pc_web",
    "X-Areaid":""
  };
  fetch(reportUrl, {
    method: 'POST', 
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headerData,
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(params),
    keepalive: true
  })
}

